const message = {
  "button.home.sendFiles": "Enviar arquivos",

  "button.options.record": "Gravar agora",
  "button.options.upload": "Escolher arquivos",
  "button.options.gallery": "Ver álbum",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Desafio de fotos",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Batalha dos Noivos",
  "button.options.foodMenu": "Cardápio",
  "button.options.schedule": "Programação",
  "button.options.feed": "Feed da Festa",
  "message.options.bingoGame": "Jogue o bingo da festa!",
  "message.options.photoChallengeGame": "Participe do desafio de fotos!",
  "message.options.quizGame": "Teste seus conhecimentos!",
  "message.options.teamMatchGame": "De qual time você faz parte?",
  "message.options.foodMenu": "Veja o cardápio da festa!",
  "message.options.schedule": "Confira a programação do evento!",
  "message.options.record": "Grave agora sua mensagem especial!",
  "message.options.upload": "Compartilhe as melhores fotos e vídeos da festa!",
  "message.options.gallery": "Veja as fotos do evento!",
  "message.options.feed": "Acompanhe a linha do tempo do evento!",

  "title.terms": "Termos de Uso",
  "title.notFound": "Ops, parece que essa página não existe.",
  "title.eventNotFound": "Erro ao acessar o evento",

  "subtitle.goBackTo": "Voltar para a",
  "subtitle.eventNotFound": "Evento não encontrado ou expirado.",

  "message.termsOfUse":
    "Ao utilizar nosso sistema você concorda com nossos <code>Termos de Uso</code>",
  "message.termsFirstParagraph":
    "Ao usar nosso sistema de envio de fotos e vídeos, você, como convidado do evento, concorda que coletamos e enviamos seus dados, incluindo  fotos, vídeos e informações pessoais, e disponibilize para o anfitrião do evento.",
  "message.termsSecondParagraph":
    "Nós não acessamos seus arquivos, a menos que seja solicitado pelo cliente para fornecer suporte técnico, limitando-se ao necessário.",
  "message.termsThirdParagraph":
    "A empresa não compartilha os dados com terceiros e mantém a confidencialidade das informações, exceto quando exigido por lei.",
  "message.shareLink": "Compartilhe seus momentos favoritos da festa!",

  // recorder
  "button.recorder.understood": "Entendi!",
  "button.recorder.close": "Fechar",
  "button.recorder.share": "Compartilhar",
  "button.recorder.home": "Retornar à tela inicial",
  "button.recorder.back": "Voltar",

  "title.recorder.permissionsToRecordAudioVideo": "Permissão para Gravar",
  "title.recorder.success": "Sucesso!",
  "title.recorder.uploading": "Enviando",
  "title.recorder.alert": "Alerta!",
  "title.recorder.saving": "Salvando",
  "title.recorder.waiting": "Aguardando",
  "title.recorder.share": "Compartilhe!",
  "title.recorder.error": "Erro!",
  "title.recorder.permissionCameraOrMicrophoneDenied":
    "Permissão não concedida",
  "title.recorder.terms": "Termos de Uso",

  "subtitle.recorder.nextScreenClickAllow":
    "Na próxima tela clique em <code>Permitir</code>.",
  "subtitle.recorder.allowReinforcement":
    "É necessário que você clique em <code>Permitir</code> para gravar sua mensagem.",
  "subtitle.recorder.share": "Convide seus amigos para gravar também!",
  "subtitle.recorder.dontRefreshPage":
    "Por favor, não atualize ou feche esta página.",
  "subtitle.recorder.status.success": "Sua mensagem foi gravada com sucesso!",
  "subtitle.recorder.browserNotSupported":
    "Seu navegador não é suportado ou a permissão não foi concedida.",
  "subtitle.recorder.tryGrantPermission":
    "1. Atualize a página e permita o uso da câmera.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Tente usar outro navegador como {chrome} ou {safari}.",
  "subtitle.recorder.mustLongerThan":
    "A mensagem deve ter uma duração maior que <code>5 segundos</code>.",
  "subtitle.recorder.offline":
    "Você está offline. Por favor, verifique sua conexão.",
  "subtitle.recorder.startRecord": "Clique para começar a gravar.",
  "subtitle.recorder.recording": "Gravando...",
  "subtitle.recorder.uploadError": "Erro ao fazer upload do vídeo.",
  "subtitle.recorder.tryAgain": "Verifique sua conexão e tente novamente.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "Não foi permitido o uso da câmera/microfone.",
  "subtitle.recorder.trySafariBrowser":
    "1. Use o navegador <code>SAFARI</code>.",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Clique no botão <code>"aA"</code> na barra da URL e em <code>"Ajustes do site"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Permita o uso</code> da câmera e microfone",
  "subtitle.recorder.refreshPage": "4. Atualize a página",
  "subtitle.recorder.tryChromeBrowser":
    "1. Use o navegador <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Acesse as configurações do site e clique em <code>"Permissões"</code>',

  "message.recorder.almostDone":
    "Quase terminando! Apenas mais alguns segundos.",
  "message.recorder.sendingMessage":
    "Agora estamos enviando sua mensagem. Pode demorar um pouco porque está cheia de coisas legais.",

  "title.recorder.upload": "Upload",

  "subtitle.recorder.filesReadyToUpload": "Arquivo pronto para o envio:",

  "subtitle.recorder.fileWithError": "Arquivo que não será enviado:",

  "message.recorder.fileSizeError": "Arquivo excede tamanho permitido",

  "button.recorder.send": "Enviar",

  "message.recorder.uploading": "Por favor, não atualize ou feche esta página.",

  "message.recorder.uploadError": "Falha ao enviar.",

  "title.recorder.uploadFailure": "Falha no envio",

  "title.recorder.completed": "Concluído",

  "message.recorder.uploadComplete": "Upload concluído",

  "message.recorder.fileUploaded": "Arquivo enviado com sucesso",

  "message.recorder.uploadFailed": "Falha ao enviar o arquivo",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Verifique sua conexão e tente novamente",

  "button.recorder.ok": "OK!",

  "title.recorder.shareMoments": "Envie sua Mensagem",

  "subtitle.recorder.forThe1YearAnniversary": "Para as Bodas de 1 Ano",

  "subtitle.recorder.now": "Para Agora",

  "message.recorder.uploadMaxFilesLimit": "Envie <code>1 vídeo</code> por vez.",

  "message.recorder.uploadLimit": "Limite máximo:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> por vídeo.",

  "button.recorder.send_video": "Enviar vídeo",

  "message.recorder.uploadTip":
    "Clique no botão acima e selecione o vídeo que acabou de gravar!",
  "title.recorder.guide.instructionsToRecord": "Instruções para Gravar",

  "subtitle.recorder.guide.instructions":
    "<code>Abra a câmera</code> do seu dispositivo no modo selfie e grave seu recado de até <code>2 minutos</code>!",

  "subtitle.recorder.guide.moreInstructions":
    "Retorne aqui para enviar seu recado!",

  "message.recorder.instructions":
    "<code>Abra o aplicativo da câmera </code> do seu dispositivo no modo selfie e grave seu recado de até <code>2 minutos</code>!",
  "button.recorder.sendVideo": "Enviar vídeo",
  "message.recorder.uploadTip.ios":
    "💡 Para melhor qualidade, selecione um vídeo da fototeca",

  // uploader
  "button.uploader.send_photos": "Enviar fotos",
  "button.uploader.send_video": "Enviar vídeo",
  "button.uploader.close": "Fechar",
  "button.uploader.share": "Compartilhar",
  "button.uploader.back": "Voltar",
  "button.uploader.send": "Enviar",
  "button.uploader.continue": "Continuar",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "Sucesso!",
  "title.uploader.uploading": "Enviando",
  "title.uploader.alert": "Alerta!",
  "title.uploader.saving": "Salvando",
  "title.uploader.waiting": "Aguardando",
  "title.uploader.share": "Compartilhe!",
  "title.uploader.error": "Erro!",
  "title.uploader.upload": "Upload",
  "title.uploader.shareMoments": "Compartilhe momentos",
  "title.uploader.uploadFailure": "Falha no envio",
  "title.uploader.completed": "Concluído",
  "title.uploader.terms": "Termos de Uso",

  "subtitle.uploader.filesWithError":
    "Arquivos que <code>não serão enviados</code>:",
  "subtitle.uploader.uploadHistory": "Envios concluídos",
  "subtitle.uploader.filesReadyToUpload": "Arquivos prontos para o envio:",

  "message.uploader.uploadMaxFilesLimit":
    "Envie até <code>50 fotos ou 1 vídeo</code> por vez.",
  "message.uploader.uploadLimit": "Limite máximo:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> por foto",
  "message.uploader.videoSizeLimit": "<code>500MB</code> por vídeo",
  "message.uploader.fileSizeError": "Arquivo excede tamanho permitido.",
  "message.uploader.uploading": "Por favor, não atualize ou feche esta página.",
  "message.uploader.uploadError": "Falha ao enviar.",
  "message.uploader.maxFilesLimitError":
    "Selecione no <code>máximo 50 fotos</code>.",
  "message.uploader.notFoundFilesToUpload":
    "<code>Nenhum arquivo pode ser enviado</code>.",
  "message.uploader.checkFileSizeAndTryAgain":
    "Por favor, verifique o <code> tamanho do arquivo</code> e tente novamente.",
  "message.uploader.uploadComplete": "Upload concluído",
  "message.uploader.allFilesUploaded": "Todos os arquivos foram enviados",
  "message.uploader.nFilesUploaded": "{n} arquivos enviados",
  "message.uploader.nFilesNotUploaded": "{n} arquivo(s) não foram enviado(s)",
  "message.uploader.noFilesUploaded": "Nenhum arquivo foi enviado",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Verifique sua conexão e tente novamente.",
  "message.uploader.uploadVerySlow":
    "Caso o envio esteja lento, selecione poucas fotos por vez",
  "message.uploader.uploadTip":
    "Para manter a qualidade do arquivo, faça o upload de arquivos da galeria do seu aparelho.",

  "title.guestForm": "Seu Perfil",
  "placeholder.guestForm.name": "Seu nome ou apelido",
  "message.guestForm.nameRequired": "Nome é obrigatório",
  "button.guestForm.takePhoto": "Tire uma selfie sua (opcional)",
  "message.guestForm.dataInfo":
    "Os dados fornecidos não são obrigatórios. Eles serão exibidos apenas como uma assinatura nas fotos e vídeos que você enviar.",
  "button.guestForm.submit": "Salvar",
  "button.guestForm.uploading": "Salvando...",
  "button.guestForm.skip": "Continuar de forma anônima",
  "message.cameraNotAvailable":
    "Não foi possível acessar a câmera. Por favor, certifique-se de que você concedeu permissões para a câmera.",
  "title.guestForm.cropPhoto": "Recortar Foto",
  "button.guestForm.selectPhoto": "Selecionar foto (opcional)",

  "title.photoChallenge": "Foto Desafio",
  "subtitle.photoChallenge.tasks": "Tarefas",
  "subtitle.photoChallenge.done": "Realizadas",
  "message.photoChallenge.intro":
    "O objetivo é tirar fotos conforme indicado em cada objetivo.",
  "message.photoChallenge.todo": "Realize um desafio",
  "message.photoChallenge.done": "Desafios finalizados",
  "button.photoChallenge.start": "Iniciar",

  "title.quiz": "Quiz",
  "subtitle.quiz.intro": "Topa o desafio?",
  "subtitle.quiz.result": "Resultado",
  "message.quiz.intro":
    "Entre todos os convidados, prove que você é a pessoa que mais conhece o casal!",
  "button.quiz.start": "Iniciar",
  "button.quiz.confirm": "Confirmar",
  "message.quiz.result":
    "Você acertou {score} de {totalQuestions} perguntas em {time} segundos",

  "title.teamMatch": "Batalha dos Noivos",
  "subtitle.teamMatch.intro": "Descubra o seu time",
  "subtitle.teamMatch.result": "Resultado",
  "message.teamMatch.intro":
    "Faça o teste e descubra se você faz parte do {teamA} ou do {teamB}!",
  "button.teamMatch.start": "Iniciar",
  "button.teamMatch.next": "Próximo",
  "message.teamMatch.result": "O seu time é <code>{team}</code>!",
  "message.teamMatch.saving": "Salvando...",

  "feed.loading": "Carregando feed...",
  "feed.empty": "Não há itens na feed ainda.",
  "feed.imageAlt": "Imagem Enviada",
  "feed.anonymousGuest": "Convidado anônimo",
  "feed.imageUploader.title": "Foto Enviada",

  "feed.quiz.title": "Quiz",
  "feed.quiz.description":
    "{guestName} completou o quiz! Resultado: {score}/{total} em {time} segundos",
  "feed.photoChallenge.title": "Foto Desafio",
  "feed.photoChallenge.description":
    "{guestName} completou o desafio: {challenge}",
  "feed.teamMatch.title": "Batalha dos Noivos",
  "feed.teamMatch.description":
    "{guestName} participou da Batalha dos Noivos. Resultado: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Novo Convidado",
  "feed.newGuest.description": "{guestName} se juntou ao evento",
  "feed.videoRecorder.title": "Nova Mensagem",
  "feed.videoRecorder.description": "{guestName} enviou uma nova mensagem",
  "feed.default.title": "Atividade",
  "feed.default.description": "Uma nova atividade ocorreu",
  //
  "feed.ctaPost.ctaButton":
    "Está gostando do evento? Poste uma foto você também!",
  "feed.imageUploader.description":
    "{guestName} enviou arquivos para a galeria da festa",
  "feed.cdt-imageUploader.title": "Nova Mensagem",
  "feed.cdt-imageUploader.description":
    "{guestName} enviou arquivos para as Bodas de 1 Ano!",
  "feed.quiz.ctaButton": "Teste seus conhecimentos",
  "feed.photoChallenge.ctaButton": "Realizar um desafio também",
  "feed.teamMatch.ctaButton": "Participar da Batalha dos Noivos",
  "feed.videoRecorder.ctaButton": "Grave uma mensagem agora",
  "feed.videoUploader.title": "Nova Mensagem",
  "feed.videoUploader.description":
    "{guestName} enviou um vídeo para a galeria da festa",
  "feed.cdt-videoUploader.title": "Nova Mensagem",
  "feed.cdt-videoUploader.description":
    "{guestName} enviou um vídeo para as Bodas de 1 Ano!",
  "feed.newPost.title": "Novo Post",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> já deixou sua mensagem para as <code>bodas de 1 ano!</code>",
  "feed.cdtVideoRecorder.ctaButton": "Faça o mesmo!",
  "feed.placeholder.newPost": "Criar post...",
  "feed.placeholder.newPostMessage": "Escreva sua mensagem...",
  "feed.bingo.result.line": "Linha",
  "feed.bingo.result.column": "Coluna",
  "feed.bingo.result.fullCard": "Cartela Cheia",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description": "{guestName} completou uma {challenge} do bingo",
  "feed.bingo.ctaButton": "Jogar bingo também",

  "feed.menu.title.interaction": "Enviar arquivos",
  "feed.menu.button.options.newPost": "Criar post",
  "feed.menu.message.options.newPost": "Crie um post agora mesmo!",
  "feed.menu.button.options.record": "Gravar agora",
  "feed.menu.message.options.record": "Grave agora sua mensagem especial!",
  "feed.menu.button.options.upload": "Escolher arquivos",
  "feed.menu.message.options.upload":
    "Compartilhe as melhores fotos e vídeos da festa!",
  "feed.menu.title.gallery": "Galeria da festa",
  "feed.menu.button.options.gallery": "Ver álbum",
  "feed.menu.message.options.gallery": "Veja as fotos do evento!",
  "feed.menu.title.games": "Jogos",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Jogue o bingo da festa!",
  "feed.menu.button.options.photoChallengeGame": "Desafio de fotos",
  "feed.menu.message.options.photoChallengeGame":
    "Participe do desafio de fotos!",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "Teste seus conhecimentos!",
  "feed.menu.button.options.teamMatchGame": "Batalha dos Noivos",
  "feed.menu.message.options.teamMatchGame": "De qual time você faz parte?",
  "feed.menu.title.info": "Sobre o evento",
  "feed.menu.button.options.foodMenu": "Cardápio",
  "feed.menu.message.options.foodMenu": "Veja o cardápio da festa!",
  "feed.menu.button.options.schedule": "Programação",
  "feed.menu.message.options.schedule": "Confira a programação da festa!",
  "feed.menu.title.guestInfo": "Suas informações",
  "feed.menu.options.anonymousGuest": "Convidado anônimo",
  "feed.menu.options.guestEditInfo": "Clique para editar suas informações!",
  "feed.menu.title.other": "Outros",
  "feed.menu.button.options.language": "Idioma",
  "feed.menu.message.options.languageInfo": "Clique para alterar o idioma!",
  "feed.button.options.cancel": "Cancelar",
  "feed.button.options.confirm": "Confirmar",
  "feed.menu.button.options.share": "Compartilhar",
  "feed.menu.message.options.shareInfo": "Compartilhe o link do evento!",
  "feed.menu.button.options.about": "Sobre a Cápsula do Tempo",
  "feed.menu.message.options.about": "Conheça a Cápsula do Tempo!",
  "feed.createPost.title": "Novo Post",
  "feed.button.creatingPost": "Criando...",
  "feed.button.createPost": "Postar",
  "feed.editImage.title": "Editar Imagem",
  "feed.newPost.selectImage": "Selecionar imagem",

  "feed.createPost.info.sendingPostImage": "Enviando imagem...",
  "feed.createPost.info.creatingPost": "Criando post...",
  "feed.createPost.info.finalizingPost": "Finalizando...",
  "feed.menu.button.options.games": "Games",

  "feed.modalGames.title": "Games da Festa",
  "feed.deletePost.title": "Excluir Post",
  "feed.deletePost.message":
    "Tem certeza que deseja excluir este post? Esta ação não pode ser desfeita.",
  //
  "title.uploader.modalMixedEventTitle":
    "QUANDO você quer que os noivos recebam sua foto ou vídeo?",
  "button.options.sendNow": "Enviar Agora",
  "message.options.sendNow":
    "Os noivos terão acesso aos arquivos imediatamente!",
  "button.options.sendLater": "Nas Bodas de 1 Ano",
  "message.options.sendLater": "Enviar para a Cápsula do Tempo do evento!",

  "button.quiz.share": "Compartilhar Resultado",
  "message.quiz.saving": "Salvando...",
  "message.quiz.congrats": "🎉 Parabéns! 🎉",
  "message.bingo.intro":
    "Consegue completar o bingo se divertindo em cada desafio?",
  "button.bingo.start": "Iniciar",
  "label.bingo.fullCard": "Cartela Cheia",
  "label.bingo.line": "Linha",
  "label.bingo.firstColumn": "1ª - Coluna",
  "label.bingo.firstRow": "1ª - Linha",
  "subtitle.bingo.results": "Resultados",
  "message.bingo.selectChallenge": "Clique para ver e realizar o desafio",
  "button.bingo.removeChallenge": "Remover desafio",
  "button.bingo.continue": "Continuar",
  "message.bingo.progress": "Continue completando os desafios do bingo!",
  "button.bingo.share": "Compartilhar",
  "message.photoChallenge.intro.new":
    "É fácil: siga as instruções e divirta-se tirando fotos!",
  "message.photoChallenge.inProgress.new":
    "Selecione um desafio abaixo e envie sua foto.",
  "button.photoChallenge.share": "Compartilhar Resultado",
  "message.photoChallenge.completed":
    "Você completou todos os {total} desafios de foto!",
  "message.photoChallenge.congrats": "🎉 Parabéns! 🎉",
  "button.teamMatch.share": "Compartilhar Resultado",

  "button.cancel": "Cancelar",
  "button.delete": "Excluir",
  "button.quiz.continue": "Continuar",
  "button.recorder.recorder.back": "Voltar",
  "button.teamMatch.continue": "Continuar",
  "cropper.remove.frame": "Remover Moldura",
  "cropper.use.frame": "Usar Moldura",
  "error.guestForm.fileTooLarge": "O arquivo deve ter no máximo 10MB",
  "error.guestForm.invalidFileType":
    "Por favor, selecione um arquivo de imagem válido",
  "error.guestForm.removePhotoFailed":
    "Falha ao remover foto. Tente novamente.",
  "error.guestForm.saveFailed": "Falha ao salvar. Tente novamente.",
  "error.guestForm.updateFailed": "Falha ao salvar. Tente novamente.",
  "error.guestForm.uploadFailed": "Falha no upload da foto. Tente novamente.",
  "title.guestForm.unsavedChanges": "Alterações não salvas",
  "message.guestForm.unsavedChanges":
    "Você tem alterações não salvas. Deseja sair sem salvar?",
  "button.guestForm.cancel": "Cancelar",
  "button.guestForm.exitWithoutSaving": "Sair sem salvar",
  "message.bingo.remove.warning":
    "Ao excluir este desafio, seus resultados serão recalculados.",
  "message.bingo.remove.warning.detail1":
    "Linhas e colunas afetadas pela exclusão serão revisadas.",
  "message.bingo.remove.warning.detail2":
    "Se houver outras conquistas completas, o horário será atualizado para o momento atual.",
  "message.guest.nameRequired": "Nome é obrigatório",
  "message.quiz.progress":
    "O quiz ainda tá rolando! Continue e mostre que manda bem!",
  "message.teamMatch.progress":
    "O jogo ainda tá rolando! Continue e descubra seu time!",
  "title.feed": "Feed da Festa",
};

export default message;
